export enum SaveStateTypeEnum {
  unkown,
  ongoing,
  done,
  failed,
}
